import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function lia(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@lia/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@lia/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@lia/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@lia/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@lia/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@lia/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}